// extracted by mini-css-extract-plugin
module.exports = {"header":"tabs_header__-8hE1","shopping-cart-title":"tabs_shopping-cart-title__1Yt6M","tabs":"tabs_tabs__1hddc"};